module.exports = __webpack_public_path__ + "img/option.9b6bf57b.png";